<!-- CDR Devices -->
<app-generic-table-header
  [config]="cdrHeaderOptions"
  (refreshEvent)="handleDataRefresh($event)"
  (filterValueChanged)="filterChanged($event)"
  (importEvent)="openImportModal()"
></app-generic-table-header>
@if (firstLoad && loadingCDRDevices) {
<mat-spinner class="centered" name="crescent"></mat-spinner>
}
<ng-template #affixTemplate let-row>
  <app-card-table-actions [row]="row" [actions]="cdrRowActions" (actionEvent)="onCdrAction($event)" [breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
</ng-template>
@if (data != null && data.length > 0) {
<app-card-table
  #CDRTable
  [tableHeaders]="cdrTableHeaders"
  [data]="data"
  [currentPage]="currentCDRPage"
  [totalItems]="totalCdrDevices"
  [options]="cdrTableOptions"
  [enableInfiteScroll]="false"
  [enableTablePagination]="true"
  [affixTemplate]="affixTemplate"
  (paginateEvent)="getPagedDevices($event)"
  [breakpoint]="ScreenSize.TABLET"
  [enableRefresher]="true"
  (dataRefreshedEvent)="refreshData($event)"
>
</app-card-table>
} @if ((data == null || data.length == 0) && !loadingCDRDevices) {
<p class="centered">No results were found.</p>
}

<ng-template #sticky> </ng-template>
